import { Box, styled } from '@mui/material'

import { theme } from 'styles/theme'

export const ContainerIcon = styled('div')(() => ({
  width: '35px',
  height: '35px',
  background: '#F8F8F8',
  borderRadius: '8px',

  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}))
export const AccordionSummaryContent = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%'
}))
export const Separator = styled('div')(() => ({
  width: '1fr',
  flexGrow: '1',
  borderTop: '0.5px dashed #CBCBCB',
  alignSelf: 'center',
  marginTop: '2px'
}))

export const DetailContent = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'column'
}))

export const DetailWrapper = styled('div')(() => ({
  marginTop: 20,
  padding: 16,
  border: `1px solid ${theme.palette.neutral[700]}`,
  borderRadius: '12px',
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'column',
  gap: '12px',
  justifyContent: 'start',
  position: 'relative',
  backgroundColor: theme.palette.neutral[900],

  [theme.breakpoints.down(560)]: {
    width: '100%',
    padding: 12
  }
}))

export const Link = styled('a')(() => ({
  margin: 0,
  padding: 0,
  fontWeight: 600,
  color: '#231F20',
  cursor: 'pointer'
}))

export const AccordionWrapper = styled('a')(() => ({
  marginTop: '12px',
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  width: 'calc(40vh + 12px)',
  [theme.breakpoints.up(450)]: {
    width: 'auto'
  }
}))

export const Divider = styled('div')(() => ({
  borderRight: `1px solid ${theme.palette.neutral[600]}`,
  height: '32px',
  alignSelf: 'center'
}))

export const ButtonsWrapper = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
  [theme.breakpoints.down(560)]: {
    width: '100%',
    justifyContent: 'none'
  }
}))

export const PopoverContainer = styled('div')(() => ({
  width: '320px',
  maxHeight: '50vh',
  display: 'flex',
  flexDirection: 'column'
}))

export const ScrollableContent = styled('div')(() => ({
  overflowY: 'auto',
  flex: 1
}))

export const FixedButtonsContainer = styled('div')(() => ({
  paddingTop: '16px',
  borderTop: `1px solid ${theme.palette.grey[200]}`,
  display: 'flex',
  justifyContent: 'space-between',
  gap: 8,
  backgroundColor: theme.palette.background.paper
}))

export const AmountWrapper = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '16px',
  padding: '16px 20px',
  backgroundColor: theme.palette.neutral[900],
  borderRadius: '12px',
  border: `1px solid ${theme.palette.neutral[700]}`,

  [theme.breakpoints.down(560)]: {
    display: 'grid',
    gridTemplateColumns: '1fr auto 1fr',
    padding: '12px 16px'
  }
}))

export const AmountContent = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '8px'
}))
